import language from '../lang';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Col, FormGroup, Input, Label, Progress} from 'reactstrap';

import helpers from '../containers/helpers';

import JSZip from 'jszip';

import DatePicker from 'react-datepicker';
import moment from 'moment';

import Multiselect from 'react-bootstrap-multiselect';

import '../css/multiselect.css';
import 'react-datepicker/dist/react-datepicker.css';

class OrderDetails extends Component {
    static initialize(lang) {
        let state = {};

        Object.keys(lang.elem).forEach(order => {
            state[order] = {
                docs: {
                    label: lang.labelDocsInfoField.empty,
                    invisible: true,
                    class: '',
                    progress: 0,
                    errs: []
                },
                requiredDocs: new Set(),
                details: {...lang.elem[order].details},
                emailDetails: {...language.ru.message.email.vashcenter.body.details[order]},
                deadline: null
            };

            if ('certs' in lang.elem[order]) {
                state[order].certs = lang.elem[order].certs;
                state[order].certs.forEach(cert => cert.selected = false);
                for (let cert of state[order].certs) {
                    if ('state' in cert) {
                        cert.state.forEach(category => {
                            state[order][category] = {};
                            state[order][category].value = '';
                            state[order][category].invisible = true;
                            state[order][category].disabled = true;
                        });
                    }
                }
                state[order].multisel = {};
                state[order].multisel.disabled = true;
            } else if ('state' in lang.elem[order])
                lang.elem[order].state.forEach(category => {
                    state[order][category] = {};
                    state[order][category].value = '';
                    state[order][category].disabled = true;
                });
        });

        return state;
    }

    static resetOrderState(state, lang) {
        if (typeof OrderDetails.ordersToReset !== 'undefined') {
            for (let order of OrderDetails.ordersToReset)
                state[order] = OrderDetails.initialize(lang)[order];

            delete OrderDetails.ordersToReset;
        }

        return state;
    }

    constructor(props) {
        super(props);

        const {lang, langCode, order, orders, getOrder, getFiles, updateOrder} = props;

        this.lang = lang.service;
        this.langRu = language.ru.service;
        this.langEmail = language.ru.message.email.vashcenter.body.details;
        this.langCode = langCode;
        this.langMsg = lang.message;
        this.order = order;
        this.orders = orders;
        this.getOrder = getOrder;
        this.getFiles = getFiles;
        this.updateOrder = updateOrder;
        this.state = {};

        moment.locale(langCode, lang.datepicker);

        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.clearFiles = this.clearFiles.bind(this);

        this.state = (typeof OrderDetails.state !== 'undefined') ? {...OrderDetails.state} : {...OrderDetails.initialize(this.lang)};
        this.state = OrderDetails.resetOrderState(this.state, this.lang);
    }

    componentWillReceiveProps({order, orders, getOrder, getFiles}) {
        this.order = order;
        this.orders = orders;
        this.getOrder = getOrder;
        this.getFiles = getFiles;

        this.setState(OrderDetails.resetOrderState(this.state, this.lang));
        OrderDetails.state = {...this.state};
    }

    handleDateChange(date) {
        this.updateOrder({name: this.order, deadline: date !== null ? date.format("DD/MM/YYYY") : helpers.getCurrentDate()});
        this.setState({[this.order]: Object.assign({}, this.state[this.order], {deadline: date})});
    }

    async handleChange(e) {
        let target = e.target;

        if (typeof target === 'undefined')
            target = this.refs.cert.$multiselect[0];

        let id = target.id;
        let value = target.value;

        switch (id) {
            case 'orderDocs':
                let files = [...target.files];
                let labelDocsInfo = this.lang.labelDocsInfoField;
                let order = this.getOrder(this.order);
                let newState = {...this.state[this.order]};
                let zipInit = new JSZip(), zipBlob;
                let zipFilesCount = 0;
                let zipFilesSize = 0;
                let naturalSize = '';
                target.value = '';

                if (order.files !== null && typeof order.files !== 'undefined') {
                    zipBlob = order.files.zip;
                    zipFilesCount = order.files.count;
                    zipFilesSize = order.files.size;

                    try {
                        zipInit = await zipInit.loadAsync(zipBlob);
                    } catch (err) {
                        console.log(err.message);
                    }
                }

                let {filesSize, filesCount, zipFinal, errs} = helpers.handleFiles(files, zipFilesSize, zipInit, this.getFiles(), this.order, this.langMsg);

                naturalSize = helpers.getNaturalFileSize(zipFilesSize + filesSize);
                zipFilesSize += filesSize;
                zipFilesCount += filesCount;

                labelDocsInfo = zipFilesCount < 2 ?
                    zipFilesCount === 0 ? labelDocsInfo.selectedZero : labelDocsInfo.selectedOne.replace(/\$1/g, naturalSize) :
                    labelDocsInfo.selectedMulti.replace(/\$1/g, zipFilesCount.toString()).replace(/\$2/g, naturalSize);

                newState.docs.class = zipFilesSize > 0 ? 'custom-file-control-selected' : '';
                newState.docs.label = labelDocsInfo;
                newState.docs.invisible = false;
                newState.docs.errs = [...errs];
                this.setState({[this.order]: newState});

                if (filesSize > 0) {
                    try {
                        zipBlob = await zipFinal.generateAsync({type: 'blob'}, progress => {
                            newState.docs.progress = Math.round(progress.percent);
                            this.setState({[this.order]: newState});
                        });

                        this.updateOrder({
                            name: this.order,
                            files: {size: zipFilesSize, count: zipFilesCount, zip: zipBlob}
                        });

                    } catch (err) {
                        console.log(err.message);
                        newState.docs.errs.push(this.langMsg.zip_err);
                        this.setState({[this.order]: newState});
                    }
                }

                break;

            case 'translateFrom':
            case 'translateTo':
                let index, indexVV, trToFrom, trToFromEmail;
                let lcode = helpers.findOptSelected(target);
                let emailValue = this.langRu.elem[this.order].language.filter(el => el[0] === lcode)[0][1];
                newState = {...this.state[this.order]};

                if (id === 'translateFrom') {
                    index = '$1';
                    indexVV = '$2';
                    trToFrom = newState.translateTo.value;
                } else {
                    index = '$2';
                    indexVV = '$1';
                    trToFrom = newState.translateFrom.value;
                }

                if (newState.details[this.order].indexOf('$') !== -1) {
                    newState.details[this.order] = newState.details[this.order].replace(index, value);
                    newState.emailDetails[this.order] = newState.emailDetails[this.order].replace(index, emailValue);
                } else {
                    newState.details[this.order] = language[this.langCode].service.elem[this.order].details[this.order].replace(index, value);
                    newState.emailDetails[this.order] = this.langEmail[this.order][this.order].replace(index, emailValue);
                    newState.details[this.order] = newState.details[this.order].replace(indexVV, trToFrom);
                    lcode = this.lang.elem[this.order].language.filter(el => el[1] === trToFrom)[0][0];
                    trToFromEmail = this.langRu.elem[this.order].language.filter(el => el[0] === lcode)[0][1];
                    newState.emailDetails[this.order] = newState.emailDetails[this.order].replace(indexVV, trToFromEmail);
                }

                newState[id].value = value;
                newState[id].disabled = false;

                this.setState({[this.order]: newState});

                if (newState.details[this.order].indexOf('$') === -1)
                    this.updateOrder({name: this.order, details: {details: newState.details[this.order], emailDetails: newState.emailDetails[this.order]}});

                break;

            case 'marriage':
                let ccode = helpers.findOptSelected(target);
                emailValue = this.langRu.elem[this.order][id].filter(el => el[0] === ccode)[0][1];
                newState = {...this.state[this.order]};
                newState[id].value = value;
                newState[id].disabled = false;

                if (newState.details[id].indexOf('$1') !== -1) {
                    newState.details[id] = newState.details[id].replace('$1', value);
                    newState.emailDetails[id] = newState.emailDetails[id].replace('$1', emailValue);
                } else {
                    newState.details[id] = language[this.langCode].service.elem[this.order].details[id].replace('$1', value);
                    newState.emailDetails[id] = this.langEmail[this.order][id].replace('$1', emailValue);
                }

                this.setState({[this.order]: newState});

                let details = {details: {[id+'_'+ccode]: newState.details[id]}, emailDetails: {[id+'_'+ccode]: newState.emailDetails[id]}};
                let orderDetails = this.getOrder(this.order).details;

                for (let key in orderDetails) {
                    for (let oDetail in orderDetails[key]) {
                        if (oDetail.indexOf(id) !== -1) {
                            delete orderDetails[key][oDetail];
                        }
                    }
                    details[key] = Object.assign({}, orderDetails[key], details[key]);
                }

                this.updateOrder({name: this.order, details: details});
                break;

            case 'cert':
                newState = this.state[this.order];
                details = {};
                let emailDetails = {};

                const setSubCert = (certName, bool) => {
                    let langCert = helpers.findCert(this.lang.elem[this.order].certs, certName).cert;

                    if ('state' in langCert) {
                        for (let state of langCert.state) {
                            newState[state].value = !bool ? newState[state].value.length ? newState[state].value : {} : {};
                            newState[state].invisible = bool;
                        }
                    }

                    if (!bool) {
                        let oDetails = this.getOrder(this.order).details.details;
                        let eDetails = this.getOrder(this.order).details.emailDetails;
                        let found = [];

                        for (let key in oDetails) {
                            if (key.startsWith(certName)) {
                                found.push(certName);
                                details[key] = oDetails[key];
                                emailDetails[key] = eDetails[key];
                            }
                        }

                        if (found.indexOf(certName) === -1) {
                            if (newState.details[certName].indexOf('$') === -1) {
                                details[certName] = newState.details[certName];
                                emailDetails[certName] = newState.emailDetails[certName];
                            } else {
                                details[certName] = langCert.label;
                                emailDetails[certName] = helpers.findCert(this.langRu.elem[this.order].certs, certName).cert.label;
                            }
                        }
                    } else {
                        let oDetails = this.lang.elem[this.order].details[certName];
                        let eDetails = this.langRu.elem[this.order].details[certName];
                        if (typeof oDetails !== 'undefined' && oDetails.indexOf('$') !== -1) {
                            newState.details[certName] = oDetails;
                            newState.emailDetails[certName] = eDetails;
                        }
                    }
                };

                let optSelected = [];
                [...target.options].filter(opt => opt.selected ? optSelected.push(opt.value) : null);

                for (let option of target.options) {
                    let {cert, pos} = helpers.findCert(newState.certs, option.value);

                    if (option.selected) {
                        setSubCert(cert.value, false);
                        cert.selected = true;

                        if (typeof cert.docs !== 'undefined')
                            cert.docs.split(',').forEach(doc => newState.requiredDocs.add(doc.trim()));

                        newState.certs[pos] = cert;

                    } else {
                        if ('selected' in cert && 'docs' in cert) {
                            cert.selected = false;
                            setSubCert(cert.value, true);

                            cert.docs.split(',').forEach(doc => {
                                doc = doc.trim();
                                let found = false;

                                for(let c of newState.certs) {
                                    if (typeof c.docs !== 'undefined') {
                                        if (cert.value !== c.value) {
                                            if (c.docs.indexOf(doc) !== -1 && optSelected.indexOf(c.value) !== -1) {
                                                found = true;
                                                break;
                                            }
                                        }
                                    }
                                }

                                if (!found)
                                    newState.requiredDocs.delete(doc);
                            });

                            newState.certs[pos] = cert;
                        }
                    }
                }

                if (JSON.stringify(details) === '{}') {
                    details = newState.details.root;
                    emailDetails = newState.emailDetails.root;
                    newState.multisel.disabled = true;
                } else
                    newState.multisel.disabled = false;

                this.setState({[this.order]: newState});
                this.updateOrder({name: this.order, details: {details: details, emailDetails: emailDetails}});

                break;

            default:
                console.warn(id + ' not found');
                break;
        }
    }

    async clearFiles(e) {
        e.preventDefault();

        let newState = {...this.state[this.order]};

        newState.docs =  {
            label: this.lang.labelDocsInfoField.empty,
            invisible: true,
            class: '',
            progress: 0,
            errs: []
        };

        this.setState({[this.order]: newState});
        await helpers.removeFromAllFiles(this.getFiles(), this.getOrder(this.order).files.zip);
        this.updateOrder({name: this.order, files: null})
    }

    render() {
        if (this.order === null)
            return null;

        let specDetails = null;
        let langOrder = this.lang.elem[this.order];
        let stateOrder = this.state[this.order];
        let labelDetail = langOrder.labelDetail;
        let labelDescr = this.lang.labelDescr;
        let serviceDescr = langOrder.description;
        let labelDeadline = this.lang.labelDeadline;
        let labelDocs = this.lang.labelDocs.concat(langOrder.labelDocs);

        if (stateOrder.requiredDocs.size > 0)
            labelDocs = labelDocs.concat(', ' + Array.from(stateOrder.requiredDocs).join(', '));

        switch(this.order) {
            case 'translation':
                let trLang = this.lang.elem[this.order].language;
                let trDisabled = stateOrder.translateFrom.disabled ? 'disabled' : '';
                let trFromValue = !stateOrder.translateFrom.value.length ? 'translateFrom' : stateOrder.translateFrom.value;
                let trToValue = !stateOrder.translateTo.value.length ? 'translateTo' : stateOrder.translateTo.value;

                specDetails = (
                    <FormGroup>
                        <Label className="label-service optional">{labelDetail}</Label>
                        <FormGroup row>
                            <Col xs="12" md="6">
                                <Input type="select" name="translateFrom" id="translateFrom" className={trDisabled} value={trFromValue} onChange={this.handleChange}>
                                    {trLang.map((tr, i) => (i === 0 ?
                                            <option key={tr[0]} value={tr[0]} disabled>{tr[1]}</option> :
                                            i !== 1 ? <option key={tr[0]} value={tr[1]} data-code={tr[0]}>{tr[1]}</option> : null
                                    ))}
                                </Input>
                            </Col>
                            <Col xs="12" md="6">
                                <Input type="select" name="translateTo" id="translateTo" className={trDisabled} value={trToValue} onChange={this.handleChange}>
                                    {trLang.map((tr, i) => (i === 1 ?
                                            <option key={tr[0]} value={tr[0]} disabled>{tr[1]}</option> :
                                            i !== 0 ? <option key={tr[0]} value={tr[1]} data-code={tr[0]}>{tr[1]}</option> : null
                                    ))}
                                </Input>
                            </Col>
                        </FormGroup>
                    </FormGroup>
                );

                break;

            case 'civil_reg':
            case 'min_justice_interior':
                let marriageValue, marriageDisabled, marriageElem;
                let multiselDisabled = stateOrder.multisel.disabled ? 'disabled': '';
                let multiSelectElem = (
                    <FormGroup>
                        <Label className="label-service optional">{langOrder.certsLabel}</Label>
                        <Multiselect name="cert" id="cert" ref="cert" data={stateOrder.certs} onChange={this.handleChange} className={multiselDisabled}
                                     nonSelectedText={langOrder.labelSelect} allSelectedText={langOrder.labelSelectedAll} nSelectedText={langOrder.labelSelected} multiple />
                    </FormGroup>
                );

                if (this.order === 'civil_reg') {
                    marriageValue = !stateOrder.marriage.value.length ? 'select' : stateOrder.marriage.value;
                    marriageDisabled = stateOrder.marriage.disabled ? 'disabled' : '';
                    marriageElem = (
                        <FormGroup hidden={stateOrder.marriage.invisible}>
                            <Label className="label-service optional">{langOrder.marriageLabel}</Label>
                            <Input type="select" name="marriage" id="marriage" className={marriageDisabled} value={marriageValue} onChange={this.handleChange}>
                                {langOrder.marriage.map((marriage, i) => (i === 0 ?
                                        <option key={marriage[0]} value={marriage[0]} disabled>{marriage[1]}</option> :
                                        <option key={marriage[0]} value={marriage[1]} data-code={marriage[0]}>{marriage[1]}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    );
                }

                specDetails = (
                    <FormGroup>
                        {multiSelectElem}
                        {marriageElem}
                    </FormGroup>
                );

                break;

            default:
                break;
        }

        return (
            <div>
                <FormGroup>
                    <Label className="label-service optional">{labelDescr}</Label>
                    <p>{serviceDescr}</p>
                </FormGroup>

                {specDetails}

                <FormGroup>
                    <Label className="label-service">{labelDocs}</Label>
                    <FormGroup row>
                        <Col xs="12" md="6">
                            <label className="custom-file">
                                <i className="glyphicon glyphicon-remove-sign" aria-hidden="true" hidden={this.state[this.order].docs.invisible} onClick={this.clearFiles} />
                                <span lang={this.langCode} className={"custom-file-control "+this.state[this.order].docs.class} data-fileinfo={this.state[this.order].docs.label} />
                                <Input lang={this.langCode} type="file" name="orderDocs" id="orderDocs" className="custom-file-input" onChange={this.handleChange} multiple={true} />
                            </label>
                        </Col>
                        <Col xs="12" md="6" className="progressPad">
                            <Progress value={this.state[this.order].docs.progress} />
                        </Col>
                        <Col xs="12" md="12">
                            <ul className="custom-feedback">
                                {this.state[this.order].docs.errs.map((err, i) => (<li key={i}>{err}</li>))}
                            </ul>
                        </Col>
                    </FormGroup>
                </FormGroup>
                <FormGroup>
                    <Label className="label-service optional">{labelDeadline}</Label>
                    <DatePicker name="deadline" id="deadline" className="form-control" placeholderText="ДД/ММ/ГГГГ" dateFormat="DD/MM/YYYY"
                                selected={this.state[this.order].deadline} minDate={moment()} maxDate={moment().add(1, "year")} onChange={this.handleDateChange} />
                </FormGroup>
            </div>

        );
    }

}

OrderDetails.propTypes = {
    lang: PropTypes.object.isRequired,
    langCode: PropTypes.string.isRequired,
    order: PropTypes.string,
    orders: PropTypes.array.isRequired,
    updateOrder: PropTypes.func.isRequired
};

export default OrderDetails;



// WEBPACK FOOTER //
// ./src/app/components/OrderDetails.js